
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-generals-28a-2019/debat",
      function () {
        return require("private-next-pages/3catinfo/eleccions-generals-28a-2019/debat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-generals-28a-2019/debat"])
      });
    }
  